/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_One_Drive_Search_SuccessInputs */

const es_tools_one_drive_search_success = /** @type {(inputs: Tools_One_Drive_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda en OneDrive completada`)
};

const en_tools_one_drive_search_success = /** @type {(inputs: Tools_One_Drive_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OneDrive search complete`)
};

/**
* | output |
* | --- |
* | "OneDrive search complete" |
*
* @param {Tools_One_Drive_Search_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_one_drive_search_success = /** @type {((inputs?: Tools_One_Drive_Search_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_One_Drive_Search_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_one_drive_search_success(inputs)
	return en_tools_one_drive_search_success(inputs)
});
export { tools_one_drive_search_success as "tools.one_drive.search_success" }